import React, { useState } from "react";
import { Container, Menu, Tab } from "semantic-ui-react";
import Page from "../../../app/common/components/Page";
import { useDispatch, useSelector } from "react-redux";
import LookupPane from "./LookupPane";
import useFirestoreCollection from "../../../app/hooks/useFirestoreCollection";
import {
  listenToAdminExpiredJobsFromFirestore,
  listenToAdminPromotionRequestsFromFirestore,
  listenToAdminUnderReviewItems,
} from "../../../app/firestore/firestoreService";
import {
  fetchAdminCompanyProfilesForReview,
  fetchAdminExpiredJobs,
  fetchAdminFreeCompanyLogosForReview,
  fetchAdminFreeJobsUnderReview,
  fetchAdminPaidCompanyLogosForReview,
  fetchAdminPaidJobsUnderReview,
  fetchAdminPromotionalRequests,
} from "../adminActions";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import {
  getAdmin,
  getCompanyFeaturedLogoRequestsToReview,
  getCompanyProfilesForReview,
  getExpiredJobToReview,
  getJobPromotionalRequests,
  getPaidJobsUnderReview,
  getUnderReviewCompanyFeaturedLogosFreebies,
  getUnderReviewFreebiesJobs,
} from "../adminSelectors";
import { useHistory } from "react-router-dom";
import { HOME_PAGE_ROUTE } from "../../../app/api/routeConstants";
import ReviewCompanyPromotionRequests from "./ReviewCompanyPromotionRequests";
import {
  FIRESTORE_COMPANY_PROFILE_COLLECTION,
  FIRESTORE_FEATURED_COMPANY_LOGOS_COLLECTION,
  FIRESTORE_JOBS_COLLECTION,
  QUERY_CODES,
} from "../../../app/firestore/firestoreConstants";
import AdminPanel from "./AdminPanel";
import ReviewJobPosts from "./ReviewJobPosts";
import ReviewCompanyProfiles from "./ReviewCompanyProfiles";
import { format, getDayOfYear } from "date-fns";
import { getFullDate } from "../../../js/helpers/dateHelpers";

const REVIEW_JOB_POSTS = "Job Posts";
const REVIEW_COMPANY_PROFILES = "Company Profiles";
const REVIEW_COMPANY_PROMOTIONS = "Promotion Services";

const JOB_POSTS = "job-posts";
const COMPANY_PROFILES = "company-profiles";
const PROMOTION_SERVICES = "promotion-services";
const LOOKUP = "lookup";
// const ACCOUNT_DELETE_REQUESTS = "account-delete-requests";
const PANEL = "panel";

const JOB_INDEX = 0;
const COMPANIES_INDEX = 1;
const PROMOTIONS_INDEX = 2;
const LOOKUP_INDEX = 3;
const PANEL_INDEX = 4;
// const ACCOUNT_DELETE_INDEX = 5;

const getIndexFromLocation = (location) => {
  if (location === JOB_POSTS) return JOB_INDEX;
  if (location === COMPANY_PROFILES) return COMPANIES_INDEX;
  if (location === PROMOTION_SERVICES) return PROMOTIONS_INDEX;
  if (location === LOOKUP) return LOOKUP_INDEX;
  // if (location === ACCOUNT_DELETE_REQUESTS) return ACCOUNT_DELETE_INDEX;
  if (location === PANEL) return PANEL_INDEX;
};

const getLocationFromIndex = (index) => {
  if (index === JOB_INDEX) return JOB_POSTS;
  if (index === COMPANIES_INDEX) return COMPANY_PROFILES;
  if (index === PROMOTIONS_INDEX) return PROMOTION_SERVICES;
  if (index === LOOKUP_INDEX) return LOOKUP;
  // if (index === ACCOUNT_DELETE_INDEX) return ACCOUNT_DELETE_REQUESTS;
  if (index === PANEL_INDEX) return PANEL;
};

export default function AdminDashboard({ match }) {
  const paramId = match.params.id;

  const dispatch = useDispatch();
  const history = useHistory();

  const { currentUserAccount } = useSelector((state) => state.account);
  const { loading } = useSelector((state) => state.async);
  const {
    jobs,
    promotionServices,
    underReviewFreebies,
    companyProfiles,
    // candidates,
  } = useSelector((state) => getAdmin(state));

  const [activeIndex, setActiveIndex] = useState(0);

  if (!currentUserAccount.isAdmin) {
    history.push(HOME_PAGE_ROUTE);
  }

  function setActiveIndexFromLocation(location) {
    const index = getIndexFromLocation(location);
    if (activeIndex !== index) setActiveMenuItem(index, location);
  }

  setActiveIndexFromLocation(paramId);

  useFirestoreCollection({
    shouldExecute: currentUserAccount.isAdmin === true,
    query: () =>
      listenToAdminUnderReviewItems({
        dbCollection: FIRESTORE_JOBS_COLLECTION,
        field: "isPaidFor",
      }),
    data: (jobsFetched) => dispatch(fetchAdminPaidJobsUnderReview(jobsFetched)),
    deps: [dispatch, currentUserAccount.isAdmin],
    queryCode: QUERY_CODES.listenToAdminUnderReviewPaidJobsFromFirestore,
  });

  useFirestoreCollection({
    shouldExecute: currentUserAccount.isAdmin === true,
    query: () =>
      listenToAdminUnderReviewItems({
        dbCollection: FIRESTORE_JOBS_COLLECTION,
        field: "isFree",
      }),
    data: (jobsFetched) => dispatch(fetchAdminFreeJobsUnderReview(jobsFetched)),
    deps: [dispatch, currentUserAccount.isAdmin],
    queryCode: QUERY_CODES.listenToAdminUnderReviewFreeJobsFromFirestore,
  });

  useFirestoreCollection({
    shouldExecute: currentUserAccount.isAdmin === true,
    query: () => listenToAdminExpiredJobsFromFirestore(),
    data: (jobsFetched) => dispatch(fetchAdminExpiredJobs(jobsFetched)),
    deps: [dispatch, currentUserAccount.isAdmin],
    queryCode: QUERY_CODES.listenToAdminExpiredJobsFromFirestore,
  });

  useFirestoreCollection({
    shouldExecute: currentUserAccount.isAdmin === true,
    query: () => listenToAdminPromotionRequestsFromFirestore(),
    data: (promotionRequests) =>
      dispatch(fetchAdminPromotionalRequests(promotionRequests)),
    deps: [dispatch, currentUserAccount.isAdmin],
    queryCode: QUERY_CODES.listenToAdminPromotionRequestsFromFirestore,
  });

  useFirestoreCollection({
    shouldExecute: currentUserAccount.isAdmin === true,
    query: () =>
      listenToAdminUnderReviewItems({
        dbCollection: FIRESTORE_FEATURED_COMPANY_LOGOS_COLLECTION,
        field: "isPaidFor",
      }),
    data: (logos) => dispatch(fetchAdminPaidCompanyLogosForReview(logos)),
    deps: [dispatch, currentUserAccount.isAdmin],
    queryCode: QUERY_CODES.listenToAdminPaidFeaturedCompanyLogosFromFirestore,
  });

  useFirestoreCollection({
    shouldExecute: currentUserAccount.isAdmin === true,
    query: () =>
      listenToAdminUnderReviewItems({
        dbCollection: FIRESTORE_FEATURED_COMPANY_LOGOS_COLLECTION,
        field: "isFree",
      }),
    data: (logos) => dispatch(fetchAdminFreeCompanyLogosForReview(logos)),
    deps: [dispatch, currentUserAccount.isAdmin],
    queryCode: QUERY_CODES.listenToAdminFreeFeaturedCompanyLogosFromFirestore,
  });

  useFirestoreCollection({
    shouldExecute: currentUserAccount.isAdmin === true,
    query: () =>
      listenToAdminUnderReviewItems({
        dbCollection: FIRESTORE_COMPANY_PROFILE_COLLECTION,
      }),
    data: (companies) =>
      dispatch(fetchAdminCompanyProfilesForReview(companies)),
    deps: [dispatch, currentUserAccount.isAdmin],
    queryCode: QUERY_CODES.listenToAdminCompanyProfilesFromFirestore,
  });

  // useFirestoreCollection({
  //   shouldExecute: currentUserAccount.isAdmin === true,
  //   query: () => listenToAdminRequestDeleteAccounts(),
  //   data: (accountsFetched) =>
  //     dispatch(fetchAdminRequestedDeleteAccounts(accountsFetched)),
  //   deps: [dispatch, currentUserAccount.isAdmin],
  //   queryCode: QUERY_CODES.listenToAdminRequestDeleteAccounts,
  // });

  function setActiveMenuItem(index, location) {
    setActiveIndex(index);
    history.push(`/admin/${location}`);
  }

  function handleMenuItemClick(index) {
    const location = getLocationFromIndex(index);
    setActiveMenuItem(index, location);
  }

  function getMenuItemButton(text, index, extra) {
    return (
      <Menu.Item key={index} onClick={() => handleMenuItemClick(index)}>
        <span className="body-blue-text">{text}</span> {extra}
      </Menu.Item>
    );
  }

  function getJobPostsCount() {
    return (
      <span className="body-blue-text">
        (
        {getPaidJobsUnderReview(jobs).length +
          getUnderReviewFreebiesJobs(underReviewFreebies).length +
          getExpiredJobToReview(jobs).length +
          getJobPromotionalRequests(jobs).length}
        )
      </span>
    );
  }

  function getCompanyPromotionRequestsCount() {
    return (
      <span className="body-blue-text">
        (
        {getCompanyFeaturedLogoRequestsToReview(promotionServices).length +
          getUnderReviewCompanyFeaturedLogosFreebies(underReviewFreebies)
            .length}
        )
      </span>
    );
  }

  function getCompanyProfilesCount() {
    return (
      <span className="body-blue-text">
        ({getCompanyProfilesForReview(companyProfiles).length})
      </span>
    );
  }

  const today = new Date();
  const dayOfYear = getDayOfYear(today);
  const year = format(today, "yy");

  const panes = [
    {
      menuItem: getMenuItemButton(
        REVIEW_JOB_POSTS,
        JOB_INDEX,
        getJobPostsCount()
      ),
      render: () => (
        <div>
          <h2>{REVIEW_JOB_POSTS}</h2>
          <div className="paragraph body-blue-text">
            {getFullDate(today)} - {dayOfYear}
            {year}
          </div>
          <ReviewJobPosts />
        </div>
      ),
    },
    {
      menuItem: getMenuItemButton(
        REVIEW_COMPANY_PROFILES,
        COMPANIES_INDEX,
        getCompanyProfilesCount()
      ),
      render: () => (
        <div>
          <h2>{REVIEW_COMPANY_PROFILES}</h2>
          <ReviewCompanyProfiles />
        </div>
      ),
    },
    {
      menuItem: getMenuItemButton(
        REVIEW_COMPANY_PROMOTIONS,
        PROMOTIONS_INDEX,
        getCompanyPromotionRequestsCount()
      ),
      render: () => (
        <div>
          <h2>Promotion Service Requests</h2>
          <ReviewCompanyPromotionRequests />
        </div>
      ),
    },
    {
      menuItem: getMenuItemButton("Lookup", LOOKUP_INDEX),
      render: () => <LookupPane />,
    },
    // {
    //   menuItem: getMenuItemButton(
    //     "Account Deletion Requests",
    //     ACCOUNT_DELETE_INDEX,
    //     getAccountDeletionRequestsCount()
    //   ),
    //   render: () => <AccountDeletionRequestsPane />,
    // },
    {
      menuItem: getMenuItemButton("Admin Panel", PANEL_INDEX),
      render: () => <AdminPanel />,
    },
  ];

  return (
    <Page title="Admin Dashboard | Hello Radius" padding="0 0 100px 0">
      {loading && <LoadingComponent />}
      <Container className="dashboard-content">
        <Tab
          activeIndex={activeIndex}
          menu={{ secondary: true, fluid: true, vertical: true }}
          grid={{ paneWidth: 12, tabWidth: 4 }}
          menuPosition="left"
          panes={panes}
        />
      </Container>
    </Page>
  );
}
